import React from "react";

import { withRouter } from "react-router-dom";
import Router from "../../routes";
import AppNavBar from "../AppNavBar/AppNavBar";

const Bar = (props) => {
  return (
    <>
      <AppNavBar {...props}>
        <Router />
      </AppNavBar>
    </>
  );
};

const Navigation = withRouter(Bar);
export default Navigation;
